// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.div_req_byte[data-v-51a37f64] {text-align:right; margin-top:2px;}\ntextarea[data-v-51a37f64] {\n  font-family: 'Courier New';\n  /* padding-right: calc(100% - 206px); */\n  padding-top: 2px;\n  padding-bottom: 2px;\n  box-sizing: border-box;\n  text-align: start;\n  writing-mode: horizontal-tb !important;\n  /* resize: none; */\n  line-height: normal;\n}\n", ""]);
// Exports
module.exports = exports;
